const TEXTAREA_FONT = "bold 11px Arial";
const TEXTAREA_HORIZONTAL_PADDING = 8;

let canvasContext;

const getTextWidth = (text) => {
  if (typeof document === "undefined") {
    return text.length * 6;
  }

  if (!canvasContext) {
    canvasContext = document.createElement("canvas").getContext("2d");
  }

  if (!canvasContext) {
    return text.length * 6;
  }

  canvasContext.font = TEXTAREA_FONT;
  return canvasContext.measureText(text).width;
};

const splitLongWord = (word, maxWidth) => {
  const parts = [];
  let current = "";

  for (const char of word) {
    const next = current + char;
    if (current && getTextWidth(next) > maxWidth) {
      parts.push(current);
      current = char;
    } else {
      current = next;
    }
  }

  if (current) {
    parts.push(current);
  }

  return parts;
};

const wrapLine = (line, maxWidth) => {
  const words = line.split(/(\s+)/).filter(Boolean);
  const wrapped = [];
  let current = "";

  words.forEach((word) => {
    if (/^\s+$/.test(word)) {
      if (current && !current.endsWith(" ")) {
        current += " ";
      }
      return;
    }

    const next = current ? `${current}${word}` : word;
    if (getTextWidth(next) <= maxWidth) {
      current = next;
      return;
    }

    if (current) {
      wrapped.push(current.replace(/\s+$/, ""));
      current = "";
    }

    if (getTextWidth(word) > maxWidth) {
      const parts = splitLongWord(word, maxWidth);
      wrapped.push(...parts.slice(0, -1));
      current = parts[parts.length - 1] || "";
    } else {
      current = word;
    }
  });

  if (current) {
    wrapped.push(current.replace(/\s+$/, ""));
  }

  return wrapped.length ? wrapped : [""];
};

export const wrapFieldText = (value, width) => {
  if (!value || !width) {
    return value || "";
  }

  const maxWidth = Math.max(Number(width) - TEXTAREA_HORIZONTAL_PADDING, 1);

  return String(value)
    .split(/\r?\n/)
    .reduce((lines, line) => lines.concat(wrapLine(line, maxWidth)), [])
    .join("\n");
};

export const wrapTextElementValue = (item) => {
  if (!item || item.fieldType !== "Text") {
    return item;
  }

  return {
    ...item,
    value: wrapFieldText(item.value, item.width),
  };
};
